/**
 * Gateway Inventory Detail query parameters.
 */
export interface GatewayInventoryDetailParams {
}

/**
 * Gateway Inventory Detail data interface.
 */
export interface GatewayInventoryDetailData {
    /**
     * The latest version of gateway available for download.
     */
    latestVersion: string;
}

/**
 * Gateway Inventory Detail class.
 */
export class GatewayInventoryDetail implements GatewayInventoryDetailData {
    /**
     * The latest version of gateway available for download.
     */
    public latestVersion: string;

    /**
     * Initializes a new instance of the GatewayInventoryDetailData Class.
     *
     * @param data the server inventory recovered data.
     */
    constructor(data?: GatewayInventoryDetailData) {
        if (data) {
            Object.assign(this, data);
        }
    }
}
